import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { useGetDimensionGroup, useIsMobileDimension } from '@beef/ui-kit/hooks';
import { ScrollableGrid } from '@fttb/common/components';
import { getActiveTariffsIds } from "../../../../store/blocks/tariffs/selectors";
import { withTariffMapper } from "../../../../store/blocks/tariffs/tariffSelectors";
export var _TariffsGrid = function _TariffsGrid(props) {
  var dimension = useGetDimensionGroup();
  var isMobile = useIsMobileDimension();
  var options = useMemo(function () {
    return _objectSpread(_objectSpread({}, ScrollableGrid.presets.medium), {}, {
      minSize: !dimension || isMobile ? 310 : 350
    });
  }, [dimension, isMobile]);
  return /*#__PURE__*/React.createElement(ScrollableGrid, _extends({}, props, {
    options: options,
    "data-t-id": "components-TariffsGrid"
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    ids: getActiveTariffsIds(state),
    levels: 1
  };
};
export var TariffsGrid = compose(connect(mapStateToProps), withTariffMapper)(_TariffsGrid);
TariffsGrid.Item = ScrollableGrid.Item;